import Notice from 'components/base/notice';
import React from 'react';

const LogisticsStatsPageSix = () => {
  return <Notice />;
};

export default LogisticsStatsPageSix;
